import * as React from 'react';
import BuieTextField from './buie-text-field';
import BlueprintTextField from './blueprint-text-field';
import VariantComponent from '../../variant-component';
import { useShouldRenderBlueprint } from '../../useShouldRenderBlueprint';

export type Props = {
  className?: string;
  description?: React.ReactNode;
  error?: React.ReactNode | string;
  infoText?: React.ReactNode | string;
  isDisabled?: boolean;
  isInTwoColumn?: boolean;
  isMultiLine?: boolean;
  isRequired?: boolean;
  label: React.ReactNode;
  limit?: number;
  onChange: (...args: unknown[]) => unknown;
  onWheel?: (...args: unknown[]) => unknown;
  type?: string;
  value: string;
  isSubmitter?: boolean;
  onBlur: (...args: unknown[]) => unknown;
};

const TextField = React.memo<Props>((props: Props) => {
  // Should be addressed in FORMS-21206
  const shouldRenderBlueprint = useShouldRenderBlueprint();

  return (
    <VariantComponent
      {...props}
      NewComponent={BlueprintTextField}
      OldComponent={BuieTextField}
      shouldRenderNewComponent={shouldRenderBlueprint}
    />
  );
});

export default TextField;
